// 共通定数のエクスポート
import tagsData from './tags.json';
import masterData from './master-data.json';

export const TUTOR_TAGS = tagsData.tutorTags;
export const RECRUITMENT_TAGS = tagsData.recruitmentTags;

export const PREFECTURES = masterData.prefectures;
export const SUBJECTS = masterData.subjects;
export const GENDERS = masterData.genders;
export const STUDENT_GENDERS = masterData.studentGenders;
export const GRADES = masterData.grades;
export const TEACHING_METHODS = masterData.teachingMethods;
export const OCCUPATIONS = masterData.occupations;

// バリデーション・時間定数
export * from './validation';
export * from './time';

// 型定義
export type Prefecture = typeof PREFECTURES[number];
export type Subject = typeof SUBJECTS[number];
export type Gender = typeof GENDERS[number];
export type StudentGender = typeof STUDENT_GENDERS[number];
export type Grade = typeof GRADES[number];
export type TeachingMethod = typeof TEACHING_METHODS[number];
export type Occupation = typeof OCCUPATIONS[number];

// タグカテゴリの型
export type TutorTagCategory = keyof typeof TUTOR_TAGS;
export type RecruitmentTagCategory = keyof typeof RECRUITMENT_TAGS;